import Cookies from "js-cookie";
import { BaseUrl } from "../config/api";
import { toHttps } from "./imageUtils";

const safeParse = (value, fallback) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
};

const fetchAllProducts = async () => {
  const response = await fetch(`${BaseUrl}/products/getallproducts`);
  if (!response.ok) {
    throw new Error("Failed to fetch products");
  }
  const data = await response.json();
  return Array.isArray(data) ? data.filter((item) => !item.isDeleted) : [];
};

export const calculateDiscount = (actualPrice, sellingPrice) => {
  if (!actualPrice || !sellingPrice) return 0;
  const discount = ((actualPrice - sellingPrice) / actualPrice) * 100;
  return Math.round(discount);
};

export const transformProductData = (data) => ({
  id: data._id || data.id,
  name: data.productName,
  price: `$${Number(data.sellingPrice || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`,
  images:
    data.images && data.images.length > 0
      ? data.images.map(toHttps)
      : [toHttps(data.categoryId?.categotyImage)],
  type: data.categoryName,
  discount: calculateDiscount(
    Number(data.actualPrice || 0),
    Number(data.sellingPrice || 0)
  ),
  _id: data._id,
  actualPrice: Number(data.actualPrice || 0),
  sellingPrice: Number(data.sellingPrice || 0),
});

export const getRandomProducts = async (excludeId = null) => {
  const allProducts = await fetchAllProducts();
  const transformed = allProducts.map(transformProductData);
  const filteredProducts = excludeId
    ? transformed.filter((product) => String(product.id) !== String(excludeId))
    : transformed;

  const shuffled = [...filteredProducts].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, 5);
};

export const addToRecentlyViewed = (productId) => {
  const recentlyViewed = Cookies.get("recentlyViewed");
  let products = safeParse(recentlyViewed, []);

  products = products.filter((id) => String(id) !== String(productId));
  products.unshift(String(productId));
  products = products.slice(0, 6);

  Cookies.set("recentlyViewed", JSON.stringify(products), { expires: 7 });
};

export const getRecentlyViewedProducts = async (currentProductId) => {
  const recentlyViewed = Cookies.get("recentlyViewed");
  if (!recentlyViewed) return [];

  const productIds = safeParse(recentlyViewed, []);
  const allProducts = await fetchAllProducts();
  const transformed = allProducts.map(transformProductData);

  return productIds
    .map((id) => transformed.find((product) => String(product.id) === String(id)))
    .filter(
      (product) => product && String(product.id) !== String(currentProductId)
    )
    .slice(0, 5);
};

export const formatPrice = (price) => {
  return Number(price).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
